import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { browserHistory } from 'react-router';
import { Modal } from 'react-bootstrap';

import * as Actions from 'actions';

import {ContainerLoader, TermsOfService} from '../';

class SignupForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        	first_name : '',
        	last_name : '',
        	email : '',
        	phone : '',
        	company : '',
        	password : '',
        	password_confirm : '',
        	agreeterms : false,
        	errors : [],
        	valid_password : false,
        	valid_password_conf : false,

        	show_tos : false
        }
        this.displayName = 'SignupForm';

        this.signup = this.signup.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }
    handleChange(event) {
    	let state = Object.assign({}, this.state);
      let item = state;
      let value = event.target.value;
      let keys = event.target.name;

      //Checkboxes
      if(event.target.type == 'checkbox') {
          value = event.target.checked;
      }

      keys = keys.split('.');
      let iterations = keys.length - 1;
      for (let i = 0; i < iterations; i++) {
          item = item[keys.shift()];
      };

      switch(event.target.name) {
      	case 'first_name' :
      	case 'last_name' :
      		if(/^[A-Za-z]*$/.test(value)) {
      			item[keys[0]] = value;
      		}
      		break;
      	case 'email' :
    			item[keys[0]] = value;
      		break;
      	case 'phone' :
      		if(/^[0-9]*$/.test(value)) {
      			item[keys[0]] = value;
      		}
      	case 'password' :
      		if(/[A-Z]+/.test(value) && /[0-9]+/.test(value) && /[A-Za-z0-9_\-\.]{8,}/.test(value)) {
      			if(!this.state.valid_password) {
      				item['valid_password'] = true;
      			}
      		}
      		else {
      			if(this.state.valid_password) {
      				item['valid_password'] = false;
      			}
      		}
      		item[keys[0]] = value;
      		break;
      	case 'password_confirm' :
      		if(value === this.state.password && this.state.valid_password === true) {
      			if(!this.state.valid_password_conf) {
      				item['valid_password_conf'] = true;
      			}
      		}
      		else {
      			if(this.state.valid_password_conf) {
      				item['valid_password_conf'] = false;
      			}
      		}
      		item[keys[0]] = value;
      		break;
        default:
        	item[keys[0]] = value;
        	break
      }

      this.setState(state);
    }

    signup(event) {
    	let temp_user_obj = Object.assign({}, this.state)
    	delete temp_user_obj.valid_password
			delete temp_user_obj.valid_password_conf

    	this.props.beginSignupClientAdmin(this.state);
    }

    componentDidUpdate() {
    	if(this.props.connection.logged_in) {
    		this.props.push('dashboard/summary');
    		return <div></div>
    	}
    }

    render() {
    	let {
    		first_name,
    		last_name,
    		email,
    		phone,
    		company,
    		password,
    		password_confirm,
    		errors,
    		agreeterms,
    	} = this.state;

      return (
      	<section className='body-sign signup-form-container'>
      		<Modal show={this.state.show_tos} onHide={() => {this.setState({show_tos : false})}}>
      			<TermsOfService />
      		</Modal>
          <div className='center-sign'>
            <a href='/' className='logo pull-left'>
              <img src='assets/images/logo-default.png' height='54' alt='Hailtrace App' />
            </a>
            <div className='panel panel-sign'>
              <div className='panel-title-sign mt-xl text-right'>
                <h2 className='title text-uppercase text-weight-bold m-none'><i className='fa fa-user mr-xs'></i> Sign Up</h2>
              </div>
              <div className='panel-body'>
								<div className='form-group mb-lg'>
									<div className='row'>
										<div className='col-sm-6'>
											<label>First Name</label>
											<input
												onChange={this.handleChange}
												name='first_name'
												type='text'
												className='form-control input-lg'
												value={first_name}
												autoFocus
											/>
										</div>
										<div className='col-sm-6'>
											<label>Last Name</label>
											<input
												onChange={this.handleChange}
												name='last_name'
												type='text'
												className='form-control input-lg'
												value={last_name}
											/>
										</div>
									</div>
								</div>
								<div className='form-group mb-lg'>
									<label>E-mail Address</label>
									<input
										onChange={this.handleChange}
										name='email'
										type='email'
										className='form-control input-lg'
										value={email}
									/>
								</div>
								<div className='form-group mb-lg'>
									<label>Phone Number</label>
									<input
										onChange={this.handleChange}
										name='phone'
										type='phone'
										className='form-control input-lg'
										value={phone}
									/>
								</div>
								<div className='row siginup-form-password-container'>
									<div className='col-sm-6 mb-lg'>
										<div className={`form-group mb-none ${!this.state.valid_password ? 'has-error' : ''}`}>
											<label>Password</label>
											<input
												onChange={this.handleChange}
												name='password'
												type='password'
												value={password}
												className='form-control input-lg'
											/>
									</div>
								</div>
								<div className='col-sm-6 mb-lg'>
									<div className={`form-group mb-none ${!this.state.valid_password_conf ? 'has-error' : ''}`}>
										<label>Password Confirmation</label>
										<input
											onChange={this.handleChange}
											name='password_confirm'
											type='password'
											value={password_confirm}
											className='form-control input-lg'
										/>
									</div>
								</div>
								{(() => {
									if(!this.state.valid_password_conf) {
										return (
											<div className='col-xs-12'>
												<label>Passwords must have at least 8 characters, an upper-case letter, and a number.</label>
											</div>
											)
									}
								})()}
								<div className='row'>
									<div className='col-sm-8'>
										<div className='checkbox-custom checkbox-default'>
											<input
												onChange={this.handleChange}
												id='AgreeTerms'
												name='agreeterms'
												value={agreeterms}
												type='checkbox'
											/>{' '}
											<label htmlFor='AgreeTerms'> I agree with <a onClick={() => {this.setState({show_tos : true})}}>terms of use</a></label>
										</div>
									</div>
									<div className='col-sm-4 text-right'>
										<button
											onClick={this.signup}
											type='submit'
											className='btn btn-primary hidden-xs'>Sign Up
										</button>
										<button
											onClick={this.signup}
											type='submit'
											className='btn btn-primary btn-block btn-lg visible-xs mt-lg'>Sign Up
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
      );
    }
}

const mapStateToProps = ({connection}) => ({connection});

export default connect(mapStateToProps, Actions)(SignupForm);



// WEBPACK FOOTER //
// ./src/browser/components/sales/signUpForm.js